<script lang="ts" setup>
  import { FormFieldContainer, type LogicalOperator } from '@logistiek-zonder-papier/lzp-library'

  const logicalOperator = defineModel<LogicalOperator>()

  const { nullable = false } = defineProps<{ label: string; nullable?: boolean }>()
</script>

<template>
  <FormFieldContainer :label="label">
    <select class="select" v-model="logicalOperator">
      <option v-if="nullable" :value="null">None</option>
      <option value="AND">Match ALL (AND)</option>
      <option value="NAND">Match NOT ALL (NAND)</option>
      <option value="OR">Match ANY (OR)</option>
      <option value="XOR">Match ODD (XOR)</option>
    </select>
  </FormFieldContainer>
</template>

<style lang="css" scoped>
  .select {
    height: 2.25rem;
    padding: 0 0.5rem;
    border: 1px solid rgb(209, 213, 219);
    border-radius: 0.375rem;
    background: var(--colours-grey-1);
    font-size: 0.875rem;
  }
</style>
